"use strict";
exports.__esModule = true;
exports.Divider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var divider_styles_1 = require("./divider.styles");
var Divider = function (props) {
    var _a = props.color, color = _a === void 0 ? 'primary' : _a, _b = props.type, type = _b === void 0 ? 'solid' : _b, className = props.className;
    return (react_1["default"].createElement("div", { className: (0, class_names_1["default"])("w-full border-t", divider_styles_1.COLOR[color], divider_styles_1.TYPE[type], className) }));
};
exports.Divider = Divider;
exports["default"] = exports.Divider;
//# sourceMappingURL=divider.js.map